import React, { Fragment } from "react";
import { Form, Input, Button, Col, Row, Radio } from "antd";
import moment from "moment-jalaali";
import { useForm } from "antd/lib/form/util";
import { fixNumbers } from "utils";
import CircularDatePicker from "../../../components/CircularDatePicker";

export const LoginRegisterForm = ({
	loading,
	submitting,
	failed,
	onFinish,
	onChange,
	phone,
	onCancel,
	nidState,
	onNidValidationRequest,
	onNidVerifyRequest,
}) => {
	// const validateStatus = failed ? "error" : null;
	moment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });
	const [form] = useForm();

	const renderNationalId = () => {
		switch (nidState) {
			case "INVALID":
				return <span style={{ color: "blue" }}>کد ملی باید با شماره موبایل شما مطابقت داشته باشد</span>;
			case "READY":
			case "OTP_WAITING":
				return (
					<Button
						type="default"
						block={true}
						disabled={"OTP_WAITING" === nidState}
						loading={submitting}
						size="large"
						onClick={(e) => {
							e.preventDefault();
							onNidValidationRequest(form.getFieldValue("nationalId"));
						}}
					>
						ارسال پیامک تایید کد ملی
					</Button>
				);
			case "OTP_FAILED":
				form.setFieldsValue({ nationalId: null });
				return <span style={{ color: "red" }}>خطا در ارسال کد تایید</span>;
			case "OTP_SENT":
			case "VERIFY_WAITING":
				return (
					<Row gutter={10}>
						<Col span={12}>
							<Form.Item name="nidOtp">
								<Input
									maxLength={5}
									placeholder="کد پنج رقمی پیامک شده"
									disabled={"VERIFY_WAITING" === nidState}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Button
								type="default"
								block
								disabled={"VERIFY_WAITING" === nidState}
								onClick={(e) => {
									e.preventDefault();
									if (form.getFieldValue("nidOtp")) {
										onNidVerifyRequest(form.getFieldValue("nidOtp"));
									}
								}}
							>
								تایید کد ملی
							</Button>
						</Col>
					</Row>
				);
			case "VERIFY_FAILED":
				return "خطا در تایید کد ملی، لطفا مطمئن شوید کد ملی با شماره موبایل شما مطابقت دارد";
			case "VALIDATED":
				return <span style={{ color: "green" }}>کد ملی تایید شد</span>;
			default:
				return null;
		}
	};

	const nationalIdEnabled = ["INVALID", "READY", "OTP_FAILED", "VERIFY_FAILED"].includes(nidState);

	return (
		<div>
			<Form form={form} onFinish={onFinish} onFieldsChange={onChange}>
				<Form.Item
					name="firstName"
					label="نام"
					rules={[{ required: true, message: "ورود نام اجباری است" }]}
					className="no-red-star f-22 mb-30"
					//    hasFeedback={failed}
					//    validateStatus={validateStatus}
				>
					<Input disabled={submitting} />
				</Form.Item>
				<Form.Item
					name="lastName"
					label="نام خانوادگی"
					rules={[{ required: true, message: "ورود نام خانوادگی اجباری است" }]}
					className="no-red-star f-22"
					//    hasFeedback={failed}
					//    validateStatus={validateStatus}
				>
					<Input disabled={submitting} />
				</Form.Item>
				<Form.Item name="gender" label="جنسیت">
						<Radio.Group>
							<Radio value="MALE">مرد</Radio>
							<Radio value="FEMALE">زن</Radio>
						</Radio.Group>
					</Form.Item>
					<Form.Item
						name="birthDate"
						label="تاریخ تولد"
						className="no-red-star f-22"
						rules={[{ required: false }]}
						//    hasFeedback={failed}
						//    validateStatus={validateStatus}
					>
						<CircularDatePicker disabled={submitting} />
					</Form.Item>
					{/* <Form.Item name="gender" label="جنسیت" className="no-red-star f-22 mb-36">
					<Select placeholder="لطفاً نوع جنسیت را مشخص کنید." allowClear>
					<Option value="MALE">مرد</Option>
					<Option value="FEMALE">زن</Option>
					</Select>
					</Form.Item> */}
					{/* <Form.Item name="nidOtp" hasFeedback={false}>
						<Input maxLength={5} type="hidden" />
					</Form.Item> */}
				<div className="national-code__style">
					<Form.Item
						name="nationalId"
						label="کد ملی"
						rules={[
							{ required: true, message: "کد ملی اجباری است" },
							{ pattern: /[0-9]{10}/, transform: fixNumbers, message: "کد ملی معتبر وارد کنید" },
						]}
						className="no-red-star f-22 mb-1"
						// hasFeedback={"VERIFY_FAILED" === nidState}
						//    validateStatus={validateStatus}
					>
						<Input maxLength={10} disabled={!nationalIdEnabled} className="input-number" />
					</Form.Item>
					{renderNationalId()}
				</div>
				{nidState === "VALIDATED" && (
					<Form.Item className="mb-1">
						<Button
							type="primary"
							htmlType="submit"
							block={true}
							disabled={submitting}
							loading={submitting}
							size="large"
						>
							ثبت اطلاعات
						</Button>
					</Form.Item>
				)}
				<Form.Item className="mb-0">
					<Button
						type="link"
						block={true}
						disabled={submitting}
						className="btn-bordered border-green"
						loading={submitting}
						size="middle"
						onClick={onCancel}
					>
						بعدا تکمیل می‌کنم!
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};
